import { render, staticRenderFns } from "./AuthenticationIndex.vue?vue&type=template&id=2b7c3ede&scoped=true"
import script from "./AuthenticationIndex.vue?vue&type=script&lang=ts"
export * from "./AuthenticationIndex.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationIndex.vue?vue&type=style&index=0&id=2b7c3ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c3ede",
  null
  
)

export default component.exports